'use client';

import React from 'react';
import { Wallet } from '@drift-labs/icons';
import MarketIcon from '../../Utils/MarketIcon';
import { EarnProductsByAsset } from 'src/hooks/useEarnProduct';
import PointsMono from '@drift-labs/icons/src/icons/components/PointsMono';
import { useEarnProductByAssetData } from 'src/hooks/useEarnProductByAssetData';
import { EarnProductMobile } from './EarnProductMobile';
import { getColorVar } from 'src/utils/theme/colorVars';
import MobileTableCard from 'src/components/Tables/cards/MobileTableCard';
import VariantTag from 'src/components/Tags/VariantTag';

interface EarnProductByAssetMobileProps {
	info: EarnProductsByAsset;
}

export const EarnProductByAssetMobile: React.FC<
	EarnProductByAssetMobileProps
> = ({ info }) => {
	const {
		showAccordion,
		walletIsConnected,
		handleToggleExpanded,
		shouldShowWalletBalance,
		getWalletBalance,
		aprStr,
	} = useEarnProductByAssetData(info);

	return (
		<MobileTableCard.Root
			expanded={showAccordion}
			setExpanded={handleToggleExpanded}
		>
			<MobileTableCard.CollapsibleHeader expanded={showAccordion}>
				<div className="inline-flex min-h-[40px] flex-1 items-center">
					<MarketIcon
						sizeClass="size-2xl"
						marketSymbol={info.spotMarket.symbol}
					/>
					<div className="mr-3 space-y-0.5 pl-4">
						<div className="flex items-center gap-2">
							<div className="typo-t2 text-text-default">
								{info.spotMarket.symbol}
							</div>
							{info.isNew && <VariantTag variant="new" />}
						</div>

						{walletIsConnected &&
							shouldShowWalletBalance(info.spotMarket.symbol) && (
								<div className="flex items-center gap-1 text-text-secondary">
									<Wallet />
									<div className="block typo-b4">
										{getWalletBalance(info.spotMarket.symbol)}
									</div>
								</div>
							)}
					</div>
				</div>

				<div className="flex items-center justify-end text-end">
					<div className="flex flex-col gap-2xs">
						<div className="text-right typo-b4 text-text-tertiary">
							{!(
								info.highestApyProductType === 'strategy_vaults' &&
								info.apyToShow > 30
							)
								? 'Up to'
								: ''}
						</div>
						<div className="flex items-center gap-1">
							{info.isPromo && (
								<PointsMono size={16} color={getColorVar('purple-link')} />
							)}
							<div className="typo-t2 text-text-positive-green-button">
								{aprStr}
							</div>
						</div>
					</div>
				</div>
			</MobileTableCard.CollapsibleHeader>

			<MobileTableCard.CollapsibleContent>
				{info.accordionOptions.map((option, optionIndex) => {
					if (option.marketIndex === undefined) {
						return null;
					}
					return (
						<EarnProductMobile
							key={`option_${optionIndex}_${info.spotMarket.symbol}`}
							earnProduct={option}
							showDetails={false}
						/>
					);
				})}
			</MobileTableCard.CollapsibleContent>
		</MobileTableCard.Root>
	);
};
